'use client'

import clsx from 'clsx'
import { useContext } from 'react'
import HeaderContext from './context/HeaderContext'

import styles from './Header.module.scss'

const HeaderTriggerButton = ({ className = '' }: { className?: string }) => {
  const { isOpen, setIsOpen, compressed, isMobile } = useContext(HeaderContext)

  const onClick = () => setIsOpen(!isOpen)

  if (isMobile === undefined) return <></>

  return (
    (compressed || isMobile) && (
      <button
        className={clsx(
          styles.headerTriggerButton,
          isOpen && styles.headerTriggerButtonOpen,
          className
        )}
        type='button'
        aria-label='Menu'
        onClick={onClick}
      >
        <span />
      </button>
    )
  )
}

export default HeaderTriggerButton
